import React from 'react'
import classNames from 'classnames'
import type { TRadioButtonCheckmarkProps } from './types'
import './styles.scss'

export const RadioButtonCheckmark = ({ className, error, size, controlStyle, checked, children }: TRadioButtonCheckmarkProps) => {
  return (
    <span
      className={classNames(
        'radioButtonCheckmark',
        className,
        size && `radioButtonCheckmark--${size}`,
        error && `radioButtonCheckmark--error`,
        checked && `radioButtonCheckmark--checked`,
        controlStyle && `radioButtonCheckmark--${controlStyle}`,
      )}
    >
      {children}
    </span>
  )
}
